import { CountOrderByEnum, Direction, Sorting } from "@/gql/types";

export interface SortBy {
  key: string;
  dir: SORTING_DIR;
}

export enum SORTING_DIR {
  ASC = "Ascend",
  DESC = "Decend",
}

export const sortByHelper = {
  toTier12Sorting: (s: SortBy): Sorting => {
    const { dir, key } = s;

    const direction: Direction =
      dir === SORTING_DIR.ASC ? Direction.Ascend : Direction.Descend;

    let orderBy: CountOrderByEnum = CountOrderByEnum.EndDate;

    switch (key.toLowerCase()) {
      case "files":
        orderBy = CountOrderByEnum.Files;
        break;
      case "count":
        orderBy = CountOrderByEnum.Count;
        break;
      case "startdate":
        orderBy = CountOrderByEnum.StartDate;
        break;
      case "enddate":
      default:
        orderBy = CountOrderByEnum.EndDate;
        break;
    }

    return {
      direction,
      orderBy,
    };
  },
};
